import TabSwitchableOptionList from './TabSwitchableOptionList.js';

export default class ToolOptionToggler {
  constructor() {
    const elGroup = document.querySelector('#toolOptionGroup');
    this._arrElList = elGroup.querySelectorAll('.optionList');
    this._current = null;
    this._closeTimeoutID = 0;
    elGroup.addEventListener('mouseleave', () => this.setClose());
    elGroup.addEventListener('mouseenter', () => this.clearClose());
    
    this._configOptionList = new TabSwitchableOptionList(
      elGroup.querySelector('.optionList[data-mode="config"]')
    );
    this._saveOptionList = new TabSwitchableOptionList(
      elGroup.querySelector('.optionList[data-mode="save"]')
    );
  }
  close() {
    if(this._current) {
      this._current.classList.remove('shown');
      document.activeElement.blur();
      this._current = null;
    }
  }
  setClose() {
    if(this._current) {
      this._closeTimeoutID = setTimeout(() => {
        if(!document.activeElement.classList.contains('avoidClosingToolOption')) {
          this.close();
        } else {
          this.setClose();
        }
      }, 1000);
    }
  }
  clearClose() {
    if(this._closeTimeoutID) {
      clearTimeout(this._closeTimeoutID);
      this._closeTimeoutID = 0;
    }
  }
  show(target, toggle = true) {
    const mode = target.dataset.option ?? target.dataset.mode;
    this._current = null;
    this._arrElList.forEach(v => {
      if(v.dataset.mode === mode) {
        if((toggle && v.classList.toggle('shown')) || (!toggle && v.classList.add('shown') === undefined)) {
          const rect = target.getBoundingClientRect();
          const baseSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--base-size'));
          v.style.top = Math.floor(rect.y + rect.height + 1 * baseSize) + 'px';
          v.style.left = Math.floor(rect.x - 2 * baseSize) + 'px';
          this._current = v;
        }
      } else {
        v.classList.remove('shown');
      }
    });
  }
}
